import { styled } from 'styled-components'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import theme from '../../../../Theme'

export const StyledSampleQuestionWrapper = styled(Box) <{ isMobile: boolean }>`
  border-radius: ${theme.spacing(1.5)};
  padding: ${(props) => props.isMobile ? `${theme.spacing(3)}` : `${theme.spacing(4)}`};
  border: 1px solid ${theme.colors.border.light};
  background: #FAFAFA;
  height: 100%;
  align-content: center;
  color: #666;
  &:hover {
    cursor: pointer;
    background: #E0E2E2;
    color: #333 !important;
  }
`

export const StyledSampleQuestion = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledContent = styled(Typography)`
  text-align: center;
  font-size: ${theme.spacing(3)} !important;
  font-weight: 500 !important;
  line-height: 1 !important;
`

